import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from '@/components/common';
import CategoryForm from '../CategoryForm';
import { CreateCategoryRequest, UpdateCategoryRequest } from '@/types/category';
import { categoryApi } from '@/api/endpoints/categories';
import { toast } from '@/store/toastStore';
import { useUIStore } from '@/store/uiStore';

interface CreateCategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const CreateCategoryModal: React.FC<CreateCategoryModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const { refreshCallbacks } = useUIStore();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (data: CreateCategoryRequest | UpdateCategoryRequest) => {
    if ('id' in data) {
      // This is an update request, but this modal is for creation only
      return;
    }

    setLoading(true);
    try {
      await categoryApi.createCategory(data);
      toast.success('Thành công', 'Danh mục đã được tạo thành công');
      
      // Trigger refresh in parent component
      refreshCallbacks.categories?.();
      
      onSuccess?.();
      onClose();
    } catch (error: any) {
      if (error.message.includes('Validation error')) {
        toast.error('Lỗi', 'Dữ liệu không hợp lệ. Vui lòng kiểm tra lại.');
      } else {
        toast.error('Lỗi', error.message || 'Có lỗi xảy ra khi tạo danh mục');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSaveAndClose = async (data: CreateCategoryRequest | UpdateCategoryRequest) => {
    if ('id' in data) {
      // This is an update request, but this modal is for creation only
      return;
    }

    setLoading(true);
    try {
      await categoryApi.createCategory(data);
      toast.success('Thành công', 'Danh mục đã được tạo thành công');
      onSuccess?.();
      onClose();
    } catch (error: any) {
      if (error.message.includes('Validation error')) {
        toast.error('Lỗi', 'Dữ liệu không hợp lệ. Vui lòng kiểm tra lại.');
      } else {
        toast.error('Lỗi', error.message || 'Có lỗi xảy ra khi tạo danh mục');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('tooltips.categories.createCategory')}
      size="lg"
    >
      <CategoryForm
        onSubmit={handleSubmit}
        onSaveAndClose={handleSaveAndClose}
        onCancel={onClose}
        loading={loading}
      />
    </Modal>
  );
};

export default CreateCategoryModal;
